
import React from 'react';
import { useIntersectionObserver } from "../hooks/useIntersectionObserver";
import { useEffect, useState } from "react";
import heroDashboard from "../assets/hero-dashboard-new.png";

const Hero = () => {
  const [ref, isVisible] = useIntersectionObserver({
    threshold: 0.1,
    triggerOnce: true
  });
  const [displayedTitle, setDisplayedTitle] = useState<string[]>([]);
  const titleWords = ["Budget,", "plan,", "and", "track", "media", "performance"];

  useEffect(() => {
    if (isVisible) {
      const animateWords = async () => {
        for (let i = 0; i < titleWords.length; i++) {
          await new Promise(resolve => setTimeout(resolve, 150));
          setDisplayedTitle(prev => [...prev, titleWords[i]]);
        }
      };
      animateWords();
    }
  }, [isVisible]);

  return <div className="relative min-h-screen">
      <div className="absolute inset-0 bg-gradient-to-b from-[#FAF9F8] via-[#FAF9F8]/90 to-[#27B5FC]/20"></div>
      
      <div ref={ref} className="relative z-10 max-w-[1200px] mx-auto px-6">
        <div className="pt-32">
          <h1 className="text-[50px] md:text-[65px] lg:text-[80px] leading-[1.1] md:leading-[1] font-charter font-medium tracking-tighter text-[#141413] mb-8 text-center">
            <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5">
              <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5 basis-full">
                {titleWords.slice(0, 3).map((word, index) => <span key={index} className={`transition-all duration-300 transform ${displayedTitle.includes(word) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                    {word}
                  </span>)}
              </div>
              
              <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5 basis-full">
                {titleWords.slice(3, 5).map((word, index) => <span key={index + 3} className={`transition-all duration-300 transform ${displayedTitle.includes(word) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                    {word}
                  </span>)}
              </div>
              
              <div className="flex flex-wrap justify-center gap-x-3 md:gap-x-5 basis-full">
                <span key={5} className={`transition-all duration-300 transform ${displayedTitle.includes(titleWords[5]) ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
                  {titleWords[5]}
                </span>
              </div>
            </div>
          </h1>
          
          <div className={`max-w-[600px] mx-auto mb-12 transition-all duration-700 delay-700 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <p className="text-base md:text-xl text-[#141413]/80 text-center">
              Take control of your media strategy with a unified platform that streamlines planning and optimizes spending.
            </p>
          </div>

          <div className={`flex flex-col sm:flex-row justify-center items-center gap-4 mb-12 transition-all duration-700 delay-700 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <a href="https://app.plannifi.com/auth/sign-up" className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-[#27B5FC] text-white px-8 py-3 rounded-full font-medium hover:bg-[#104B60] hover:text-white transition-colors">
                Get Started for Free
              </a>
              <a href="https://calendly.com/plannifi-demo/30min?back=1" className="flex-1 sm:flex-none inline-flex items-center justify-center gap-2 bg-black text-white px-8 py-3 rounded-full font-medium hover:bg-[#104B60] transition-colors">
                Book a Demo
              </a>
            </div>
          </div>

          <div className={`max-w-[800px] mx-auto rounded-xl shadow-xl overflow-hidden transition-all duration-700 delay-700 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <video 
              src="/plannifi-lp-video-compressed.mp4"
              poster="/lovable-uploads/dash-2.jpg"
              controls
              className="w-full h-auto"
              preload="metadata"
            >
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </div>
    </div>;
};

export default Hero;
